import {
  GET_DEALSTATUS,
  GET_DEALSTATUS_SUCCESS,
  GET_DEALSTATUS_FAIL,
  DELETE_DEALSTATUS,
  DELETE_DEALSTATUS_SUCCESS,
  DELETE_DEALSTATUS_FAIL,
  UPDATE_DEALSTATUS,
  UPDATE_DEALSTATUS_SUCCESS,
  UPDATE_DEALSTATUS_FAIL,
  ADD_NEW_DEALSTATUS,
  ADD_DEALSTATUS_SUCCESS,
  ADD_DEALSTATUS_FAIL,
  DEALSTATUS_LOADING,
  DEALSTATUS_RESET,
} from "./actionType";

export const resetDealStatusState = (actionType) => ({
  type: DEALSTATUS_RESET,
  payload: { actionType },
});

export const getDealStatusSuccess = (actionType, data) => ({
  type: GET_DEALSTATUS_SUCCESS,
  payload: { actionType, data },
});

export const getDealStatusFail = (actionType, error) => ({
  type: GET_DEALSTATUS_FAIL,
  payload: { actionType, error },
});

export const getDealStatus = (data) => ({
  type: GET_DEALSTATUS,
  payload: data,
});

export const getDealStatusLoading = () => ({
  type: DEALSTATUS_LOADING,
});

export const deleteDealStatus = (data) => ({
  type: DELETE_DEALSTATUS,
  payload: data,
});

export const deleteDealStatusSuccess = (data) => ({
  type: DELETE_DEALSTATUS_SUCCESS,
  payload: data,
});

export const deleteDealStatusFail = (error) => ({
  type: DELETE_DEALSTATUS_FAIL,
  payload: error,
});

export const updateDealStatus = (data) => ({
  type: UPDATE_DEALSTATUS,
  payload: data,
});

export const updateDealStatusFail = (error) => ({
  type: UPDATE_DEALSTATUS_FAIL,
  payload: error,
});

export const updateDealStatusSuccess = (data) => ({
  type: UPDATE_DEALSTATUS_SUCCESS,
  payload: data,
});

export const addNewDealStatus = (data) => ({
  type: ADD_NEW_DEALSTATUS,
  payload: data,
});

export const addDealStatusSuccess = (data) => ({
  type: ADD_DEALSTATUS_SUCCESS,
  payload: data,
});

export const addDealStatusFail = (error) => ({
  type: ADD_DEALSTATUS_FAIL,
  payload: error,
});
